import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { red400 } from 'material-ui/styles/colors';

const buttonDeleteStyle = {
    marginLeft: 10
};

const strongStyle = {
    color: red400
};

function DeleteDialog({ isOpen, deleteId, deleteName, deletePack, toggleCreateDialog }) {
    return (
        <Dialog
            title="Create new pack"
            modal={false}
            open={isOpen}
            onRequestClose={toggleCreateDialog}
            actions={[
                <RaisedButton key="Cancel" label="Cancel" secondary onClick={toggleCreateDialog} />,
                <FlatButton
                    key="Delete"
                    label="Delete"
                    primary
                    style={buttonDeleteStyle}
                    onClick={() => {
                        deletePack(deleteId);
                    }}
                />
            ]}
        >
            <span>
                Are you sure you want to delete pack <strong style={strongStyle}>{deleteName}</strong> ? This can&apos;t
                be undone.
            </span>
        </Dialog>
    );
}

DeleteDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    deleteId: PropTypes.string.isRequired,
    deleteName: PropTypes.string.isRequired,
    deletePack: PropTypes.func.isRequired,
    toggleCreateDialog: PropTypes.func.isRequired
};

export default DeleteDialog;



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/DeleteDialog.js
 **/